import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6fa47d58")

_pushScopeId("data-v-6fa47d58")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" カルテデータメニュー ")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("カルテ項目")
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("を作成 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("経穴リスト")
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("を作成 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("カルテ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("テンプレート")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("を作成 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("問診を作成 ")
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("カルテ項目")
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("を閲覧 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("経穴リスト")
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("を閲覧 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("カルテ")
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("テンプレート")
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("を閲覧 ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("問診を閲覧 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      (_ctx.dataWrite)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", {
              class: ["button-row", _ctx.$mq]
            }, [
              _createVNode(_component_normal_button, {
                class: "menu-button",
                state: "normal",
                large: true,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_data_item`)))
              }, {
                default: _withId(() => [
                  _hoisted_3,
                  _hoisted_4,
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_normal_button, {
                class: "menu-button",
                state: "normal",
                large: true,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_data_acu`)))
              }, {
                default: _withId(() => [
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_normal_button, {
                class: "menu-button",
                state: "normal",
                large: true,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_template`)))
              }, {
                default: _withId(() => [
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13
                ]),
                _: 1
              })
            ], 2),
            _createVNode("div", {
              class: ["button-row", _ctx.$mq]
            }, [
              _createVNode(_component_normal_button, {
                class: "menu-button",
                state: "normal",
                large: true,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/inquiry_item`)))
              }, {
                default: _withId(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ], 2)
          ]))
        : (_ctx.dataRead)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("div", {
                class: ["button-row", _ctx.$mq]
              }, [
                _createVNode(_component_normal_button, {
                  class: "menu-button",
                  state: "normal",
                  large: true,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_data_item`)))
                }, {
                  default: _withId(() => [
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18
                  ]),
                  _: 1
                }),
                _createVNode(_component_normal_button, {
                  class: "menu-button",
                  state: "normal",
                  large: true,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_data_acu`)))
                }, {
                  default: _withId(() => [
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21
                  ]),
                  _: 1
                }),
                _createVNode(_component_normal_button, {
                  class: "menu-button",
                  state: "normal",
                  large: true,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_template`)))
                }, {
                  default: _withId(() => [
                    _hoisted_22,
                    _hoisted_23,
                    _hoisted_24,
                    _hoisted_25,
                    _hoisted_26
                  ]),
                  _: 1
                })
              ], 2),
              _createVNode("div", {
                class: ["button-row", _ctx.$mq]
              }, [
                _createVNode(_component_normal_button, {
                  class: "menu-button",
                  state: "normal",
                  large: true,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/inquiry_item`)))
                }, {
                  default: _withId(() => [
                    _hoisted_27
                  ]),
                  _: 1
                })
              ], 2)
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})